import { EBuidlingHouseLine } from 'shared/types/filters/advanced/buildlingHouseLine';

export const mapBuildingHouseType = {
  [EBuidlingHouseLine.First]: 'Первая',
  [EBuidlingHouseLine.Second]: 'Вторая',
};
